export default {
  header: 'Recente bewegingen',
  empty: 'Nog geen bewegingen.',
  date: 'Datum',
  direction: 'Richting',
  product: 'Product',
  bottleSize: 'Flesgrootte',
  amount: 'Aantal',
  batchId: 'Batch-ID',
  uniqueId: 'Unieke ID',
  note: 'Opmerking',
  sold: 'VERKOCHT',
  out: 'UIT',
  in: 'IN',
};
